import React from 'react';
import Loadable from 'react-loadable';

const LoadableWidget = Loadable({
  loader: () => import(/* webpackChunkName: "PokerCashGamesWidget" */ './PokerCashGamesWidget'),
  modules: ['./PokerCashGamesWidget'],
  loading: () => <div />
});

export default LoadableWidget;
